import React from "react";
import EFitsAndWellnessbanner from "../../AVHRBanner/Benfits.png";
import {
  FaStethoscope,
  FaTooth,
  FaEye,
  FaUserMd,
  FaDatabase,
  FaHospitalSymbol,
  FaUserShield,
  FaSpa,
  FaUsers,
  FaSmileBeam,
  FaBrain,
  FaHeartbeat,
} from "react-icons/fa";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

function EmployeeBenefitsAndWellnessPortal() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const cards = [
    {
      // icon: <FaStethoscope size={30} />,
        icon: <span style={{ fontSize: "30px" }}>🩺</span>,
      title: "Health Check-up*",
      note: "(Employee Only)",
    },
    {
      // icon: <FaTooth size={30} />,
          icon: <span style={{ fontSize: "30px" }}>🦷</span>,
      title: "Dental Check-Up",
      note: "(Employee & Family)",
    },
    {
      // icon: <FaEye size={30} />,
      icon: <span style={{ fontSize: "30px" }}>👁️</span>,
      title: "Vision Check-Up",
      note: "(Employee & Family)",
    },
    {
      icon: <span style={{ fontSize: "30px" }}>👨‍⚕️</span>,
      title: "Online Doctor Consultations",
      note: "(Employee & Family)",
    },
    {
      // icon: <FaDatabase size={30} />,
       
        icon: <span style={{ fontSize: "30px" }}>💾</span>,
      title: "Database Check",
      note: "(Employee & Family)",
    },
    { 
      // icon: <FaHospitalSymbol size={30} />, 
      icon: <span style={{ fontSize: "30px" }}>🏥</span>,
    title: "Group Medical Coverage" },

    {
      // icon: <FaUserShield size={30} />,
      icon: <span style={{ fontSize: "30px" }}>🛡️</span>,
      title: "Group Personal Accidental Policy",
    },
    { 
      // icon: <FaSpa size={30} />, 
      icon: <span style={{ fontSize: "30px" }}>🧘</span>,
      title: "Daily Guided Meditation Sessions" },
    {
      // icon: <FaUsers size={30} />,
       icon: <span style={{ fontSize: "30px" }}>👨‍👩‍👧‍👦</span>,
      title: "Weekly Engagement Sessions",
      note: "(Employee & Family)",
    },
    {
      // icon: <FaSmileBeam size={30} />,
       icon: <span style={{ fontSize: "30px" }}>😊</span>,
      title: "Monthly Happiness Workshop",
      note: "(Employee Only)",
    },
    {
      // icon: <FaBrain size={30} />,
       icon: <span style={{ fontSize: "30px" }}>🧠</span>,
      title: "Online Psychologist Consultations",
      note: "(Employee & Family)",
    },
    {
      // icon: <FaHeartbeat size={30} />,
         icon: <span style={{ fontSize: "30px" }}>🥗</span>,
      title: "Online Nutrition Consultations",
      note: "(Employee & Family)",
    },
  ];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={EFitsAndWellnessbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest avhrProject-bannerTextColour-B">
            <div className="text-bannar max-w-3xl text-left">
              <p className="edu-support-text uppercase ">Our Services</p>

              <h1 className="career-library-heading ">
                Employee Benefits
                <br />
                And Wellness
              </h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="custom-grid p-3">
          {cards.map((card, idx) => (
            <div className="custom-col" key={idx}>
              <div className="p-4 border-round-lg shadow-2 text-center flex flex-column align-items-center justify-content-center h-full card-hover-effect">
                <div className="icon-circle mb-2 flex align-items-center justify-content-center">
                  {card.icon}
                </div>
                <h4 className="mb-2 avhrProject-h4">{card.title}</h4>
                {card.note && <p className="avhrProject-p">{card.note}</p>}
              </div>
            </div>
          ))}
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(-120deg, #FDB26C, #FFF2A6)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2">
              Boosting well-being through smart benefits and wellness
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default EmployeeBenefitsAndWellnessPortal;
